export default __webpack_public_path__ + "static/graphs-95528d547b69a462057aa2a9f576bfeb.png";